module.exports = __webpack_public_path__ + "themes/mf/img/prize-7.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-7.png
// module id = 98
// module chunks = 3